'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isVisible = function (parent, child) {
    if (!parent || !child) {
        return false;
    }
    return !(child.offsetLeft - parent.offsetLeft > parent.offsetWidth ||
        child.offsetTop - parent.offsetTop > parent.offsetHeight);
};
var setTabIndex = function (node, index) {
    if (node) {
        node.tabIndex = index;
    }
};

exports.isVisible = isVisible;
exports.setTabIndex = setTabIndex;
//# sourceMappingURL=utils.js.map
